import { FC, useState } from 'react';

import { BodySmall, Box, Button, H6, Snackbar, Tooltip } from '@parspec/pixel';

import { MFA } from './MFA';
import ChangePasswordModal from './ChangePasswordModal';
import { SSO_DISABLED_MSG } from 'src/features/shared/constants';
import { useGetUserProfileInfoQuery } from '../queries';
import SSO from './SSO';
import { useSnackbar } from 'src/features/shared/hooks/useSnackbar';

const SecurityTab: FC = () => {
    const [openChangePasswordForm, setOpenChangePasswordForm] = useState(false);
    const { snackbarInfo, setSnackbarOpen, setSnackbarClose } = useSnackbar();

    const { data: userData } = useGetUserProfileInfoQuery();

    const isSSOEnabled = Boolean(userData?.data?.is_sso_enabled);

    return (
        <>
            <Snackbar open={snackbarInfo.open} onClose={() => setSnackbarClose()} message={snackbarInfo.message} />
            <Box>
                <H6>Security</H6>
                <Box maxWidth="50%">
                    <Box mt={4}>
                        <BodySmall color="text.primary">Password</BodySmall>
                        <Box mt={3}>
                            <Tooltip title={isSSOEnabled ? SSO_DISABLED_MSG : ''}>
                                <span>
                                    <Button color="secondary" variant="outlined" onClick={() => setOpenChangePasswordForm(true)} disabled={isSSOEnabled}>
                                        Change Password
                                    </Button>
                                </span>
                            </Tooltip>
                        </Box>
                    </Box>
                </Box>
                <SSO handleSnackbarMsg={setSnackbarOpen} />
                <MFA handleSnackbarMsg={setSnackbarOpen} />
                {openChangePasswordForm && <ChangePasswordModal open={openChangePasswordForm} onClose={() => setOpenChangePasswordForm(false)} handleSnackbarMsg={setSnackbarOpen} />}
            </Box>
        </>
    );
};

export default SecurityTab;
